import React from 'react';

const BarGraphFillSvg = (props) => (
    <svg
        className="bar-graph-fill_svg__eds-icon--bar-chart-fill__svg"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            className="bar-graph-fill_svg__eds-icon--bar-chart-fill__base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17 21h-3V10h-4v11H7V6H3v15H2v1h20v-1h-1V2h-4"
        />
    </svg>
);

BarGraphFillSvg.displayName = 'BarGraphFillSvg';
export default BarGraphFillSvg;
